import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import EnvConfig from 'env.config';
import LocalisedMessage from 'components/Common/LocalisedMessage';

const contains = (intl, messageId) => intl && !!intl.messages[messageId];

const CookieBanner = ({ intl }) => {
  const [show, setShow] = useState(true);

  const setCookies = () => {
    document.cookie = `${ EnvConfig.cookieConsentName }=true; path=/; expires=Fri, 01 Jan 2038 00:00:00 GMT; samesite=lax`;
    setShow(false);
  };

  const getCookieLinks = () => {
    const privacyLink = contains(intl, 'footer.privacy');
    const termsOfUseLink = contains(intl, 'footer.termsOfUse');
    const cookiesLink = contains(intl, 'footer.cookies');
    const { linkOverrides } = intl.messages;
    const privacyLinkUrl = linkOverrides?.find(link => link.key === 'privacy' && link.value !== '')?.value ?? '/links/privacy';
    const cookiesLinkUrl = linkOverrides?.find(link => link.key === 'cookies' && link.value !== '')?.value ?? '/links/cookies';
    const termsOfUseLinkUrl = linkOverrides?.find(link => link.key === 'termsOfUse' && link.value !== '')?.value ?? '/links/termsOfUse';

    const links = (privacyLink ? 1 : 0) + (termsOfUseLink ? 1 : 0) + (cookiesLink ? 1 : 0);
    if (links === 0) {
      return '';
    }
    return <ul>
      { privacyLink && <li><a href={ privacyLinkUrl } target="_blank" rel="noopener noreferrer"><LocalisedMessage id="footer.privacy.title" /></a></li> }
      { termsOfUseLink && <li><a href={ termsOfUseLinkUrl } target="_blank" rel="noopener noreferrer"><LocalisedMessage id="footer.termsOfUse.title" /></a></li> }
      { cookiesLink && <li><a href={ cookiesLinkUrl } target="_blank" rel="noopener noreferrer"><LocalisedMessage id="footer.cookies.title" /></a></li> }
    </ul>;
  };

  return (
    show && <React.Fragment> <div className="cookie-banner">
      <div className="cookie-content">
        <div className="close-cookie">
          <button
            className="close-cookie-button"
            aria-label={ intl.formatMessage({ id: 'accessibility.cookieBanner.close' }) }
            type="button"
            onClick={ () => setCookies() }
            onKeyDown={ () => setCookies() }
          >
            <FontAwesomeIcon
              icon="times"
              className="icon"
            />
          </button>
        </div>
        <div className="cookie-message">
          <LocalisedMessage id="cookieBanner.content" />
          { getCookieLinks() }
        </div>
      </div>
    </div>
    </React.Fragment>
  );
};

CookieBanner.propTypes = {
  intl: PropTypes.shape({
    messages: PropTypes.any,
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

export default injectIntl(CookieBanner);
